import React, { useState } from 'react';
import ModuleWrapper from './ModuleWrapper';
const Formation = ({ pll, element, formData, setFormData, attributes }) => {
    const [attrs, setAttrs] = useState({
        showProgram: false
    });
    const topInformations = (element.informations != "") ? React.createElement("div", { className: "top-information" }, element.informations) : "";
    const mandatoryInformations = (element.mandatory == true) ? React.createElement("div", { className: "mandatory-information" },
        React.createElement("span", null, pll("Formation obligatoire"))) : "";
    const showProgram = (e) => {
        e.preventDefault();
        setAttrs(Object.assign(Object.assign({}, attrs), { showProgram: !attrs.showProgram }));
    };
    return (React.createElement("div", { className: "formation-node" },
        React.createElement("div", { className: "days" },
            element.days,
            " ",
            element.days > 1 ? pll("jours") : pll("jour")),
        React.createElement("div", { className: "description" },
            mandatoryInformations,
            topInformations,
            React.createElement("h3", null, element.name),
            React.createElement("div", { className: "description ul-styled", dangerouslySetInnerHTML: { __html: element.description } })),
        React.createElement(ModuleWrapper, { formData: formData, setFormData: setFormData, attributes: attributes, modules: element.modules, pll: pll, options: { mandatory: element.mandatory, type: "multiple", group: `for${element.id}`, formationId: element.id, formationName: element.name, formationInformations: element.informations } }),
        React.createElement("div", { className: `program ul-styled ${attrs.showProgram ? "visible" : "hidden"}`, dangerouslySetInnerHTML: { __html: element.program } }),
        React.createElement("div", { className: "action" },
            React.createElement("a", { onClick: showProgram, className: `Button ${attrs.showProgram ? "less" : "more"}` }, attrs.showProgram ? pll("- Réduire") : pll("+ En savoir plus")))));
};
export default Formation;
